import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

const KEYS = 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,123'.split(
  ',',
);

@customElement('designers-component')
class DesignersComponent extends LitElement {
  @property({ type: Object, attribute: 'vendors-sorted' })
  accessor vendorsSorted = {};

  connectedCallback() {
    super.connectedCallback();
  }

  createRenderRoot() {
    return this;
  }

  _handleizeVendorName(name) {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  render() {
    return KEYS.map((key) => {
      const designers = this.vendorsSorted[key] || [];
      return html`
        <div
          class="
            max-w-[60.938rem] mx-auto px-5
            scroll-mt-[12rem] md:scroll-mt-[15rem]
          "
          id="designer-group-${key}"
        >
          <h3 class="pb-3">${key.toUpperCase()}</h2>
          <div
            class="
              border border-b-0 border-l-0 border-r-0 border-gray-500
              pb-[1.375rem] md:pb-8 pt-5 md:pt-[1.875rem]
              columns-1 md:columns-4
              body-2
            "
          >
            ${designers.map(
              (designer) =>
                html`<a
                  class="block no-underline pb-4"
                  data-designer-group="${key}"
                  href="${window.Shopify.routes
                    .root}collections/${this._handleizeVendorName(designer)}"
                  >${designer}</a
                >`,
            )}
          </div>
        </div>
      `;
    });
  }
}

export default DesignersComponent;
